import { FC } from 'react'
import * as styles from 'styles/pages/Styleguide.css'

export const SGFeedPost: FC = () => {
  return (
    <div className={ styles.sgFeed }>
      {/*
        <div className={ styles.post }>
          <FeedPost
            postUid={ 1 }
            userId='1'

            memberFeedUid='1'
            isPostLiked={ false }
            isPostFollowed={ false }
            isOwn
            text='Check out this great article! It helped me save money on my http://google.com vacation. #vacay#savings #whoooo #party'
            likes_count={ 5 }
            comments_count={ 0 }

            isLikeLoading={ false }
            isPostFollowLoading={ false }
            isPostEditing={ false }

            onPostLike={ (_isLiked: boolean) => {} }
            onPostFollow={ (_isFollowing: boolean) => {} }
            onPostEdit={ (_isEditing: boolean) => {} }
          />
        </div>
        <div className={ styles.post }>
          <FeedPost
            postUid={ 2 }
            userId={ 2 }
            compatibilityRatio={ .47 }
            text='www.domain.com text1 #tag1 text2 #tag2 text3'
            authorName='dagastina7y'
            isFollowingAuthor={ false }
            isPostFollowing={ false }
            isReported={ false }
            hasMoreCount={ 0 }
            isAuthorVerified={ Math.random() > .5 }
            isOwnPost
            date={ new Date(+new Date() - Math.round( Math.random() * 1000 * 60 * 60 * 24 * 7 )).toISOString() }
          />
        </div>
        <div className={ styles.post }>
          <FeedPost
            postUid={ 3 }
            userId={ 3 }
            compatibilityRatio={ .5 }
            text='#tag1 text1 #tag2 text1 #tag3'
            authorName='Bwimbridgen9'
            hasMoreCount={ Math.round(Math.random() * 100) }
            isAuthorVerified={ Math.random() > .5 }
            isOwnPost
            isFollowingAuthor={ false }
            isPostFollowing={ false }
            isReported={ false }
            date={ new Date(+new Date() - Math.round( Math.random() * 1000 * 60 * 60 * 24 * 30 )).toISOString() }
          />
        </div>
        <div className={ styles.post }>
          <FeedPost
            postUid={ 4 }
            userId={ 4 }
            compatibilityRatio={ .8 }
            text='#tag1 text1 #tag2 text1 #tag3 https://bit.ly/21349'
            authorName='hdoey8h'
            liked
            hasMoreCount={ Math.round(Math.random() * 100) }
            isAuthorVerified={ Math.random() > .5 }
            isOwnPost={ false }
            isFollowingAuthor
            isPostFollowing
            isReported={ false }
            date={ new Date(+new Date() - Math.round( Math.random() * 1000 * 60 * 60 * 24 * 365 )).toISOString() }
          />
        </div>
        <div className={ styles.post }>
          <FeedPost
            postUid={ 5 }
            userId={ 5 }
            compatibilityRatio={ 1 }
            text='https://bit.ly/21349  #tag1 text1 #tag2 text1 #tag3 https://bit.ly/21349'
            authorName='mfetherstone2f'
            hasMoreCount={ Math.round(Math.random() * 100) }
            isAuthorVerified={ Math.random() > .5 }
            isOwnPost={ false }
            isFollowingAuthor
            isPostFollowing
            isReported={ false }
            date={ new Date(+new Date() - Math.round( Math.random() * 1000 * 60 * 60 * 24 * 365 * 2 )).toISOString() }
          />
        </div>
      */}
    </div>
  )
}
